// extracted by mini-css-extract-plugin
export var dividerContainer = "_8y-0";
export var line = "_8y-1";